<template>
  <a v-if="previewUrl" :href="previewUrl" class="book-preview-link">
    <img class="book-preview-link__icon" :src="playIcon" :alt="'Listen to first key idea'" />

    <div class="book-preview-link__copy">
      {{ $t("copy") }}
    </div>
  </a>
</template>

<script>
import playIcon from "./images/play.svg"

export default {
  name: "BookPreviewLink",
  props: {
    previewUrl: { type: String, default: null }
  },
  data() {
    return {
      playIcon
    }
  },
  i18n: {
    messages: {
      en: {
        copy: "Listen to the first key idea"
      },
      de: {
        copy: "Hörprobe öffnen"
      }
    }
  }
}
</script>

<style lang="scss">
.book-preview-link {
  display: flex;
  align-items: center;

  &__icon {
    margin-right: $spacing-8;
  }

  &__copy {
    @include font-style(caption, $color: $blue);
  }
}
</style>
